// extracted by mini-css-extract-plugin
module.exports = {"carCareNavCard":"car-care-menu_carCareNavCard__gWyYu","list":"car-care-menu_list__2OUnV"};